
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { RecadastroService } from '../../../services/Recadastro.service';
import { AuthService } from '../../../../../services/auth.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
declare var L: any;

@Component({
  selector: 'app-servicos-pendentes',
  standalone: false,
  templateUrl: './servicos-pendentes.component.html',
  styleUrls: ['./servicos-pendentes.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicosPendentesComponent implements OnInit {
  get canSeeAnalyzeButton(): boolean {
    const role = (this.currentUserRole || '').toString().trim().toLowerCase();
    return role === 'administrador' || role === 'superadministrador';
  }
  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      try { this.savePaginationState(); } catch(e) { /* ignore */ }
      this.aplicarFiltro();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      try { this.savePaginationState(); } catch(e) { /* ignore */ }
      this.aplicarFiltro();
    }
  }
  public motivoInvalido = '';
  public mostrarModalInvalida = false;
  public motivoInvalidoTouched = false;
  showFiltros: boolean = false;
  // Filtros extras para pesquisa detalhada
  filtroMatricula: string = '';
  filtroNumero: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumeroVistoria: string = '';
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }
  // Filtros
  filtroUsuarioId: string = '';
  // Compatibility with `servicos` template
  filtroStatus: string = '';
  // Leave date filters empty by default so the user selects the period manually
  filtroDataInicio: string = '';
  filtroDataFim: string = '';
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];

  servicos: any[] = [];
  servicosFiltrados: any[] = [];
  erro: string | null = null;

  // Referência ao Math para uso no template
  Math = Math;
  servicoDetalhes: any = null;
  mostrarModalFoto = false;
  fotoSelecionada = '';
  processandoStatus = false;
  statusProcessado = false;
  statusFinal: 'Validado' | 'Invalido' | null = null;
  currentUserRole: string = '';
  viewLoading: { [servicoId: string]: boolean } = {};

  get canSeeValidationButtons(): boolean {
    // Só permite para role 'Administrador' — tentamos extrair a role de qualquer entrada do localStorage
    const roleFound = this.getRoleFromLocalStorage();
    const role = (roleFound || '').toString().trim().toLowerCase();
    const canShow = role === 'administrador';
    return canShow;
  }

  /**
   * Tenta ler um objeto de usuário/sessão a partir de várias chaves possíveis no localStorage.
   */
  private getStoredUser(): any | null {
    const candidateKeys = ['userData', 'usuario', 'usuarioLogadoSync', 'usuarioLogado', 'user'];
    for (const key of candidateKeys) {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) continue;
        const parsed = JSON.parse(raw);
        if (parsed) return parsed;
      } catch (e) {
        // ignore JSON parse errors and continue
      }
    }

    // As última tentativa: procura por um objeto armazenado na chave 'userData' como stringified nested under other keys
    try {
      const rawAll = localStorage.getItem('userData');
      if (rawAll) {
        const parsed = JSON.parse(rawAll);
        if (parsed) return parsed;
      }
    } catch (e) {
      // ignore
    }

    return null;
  }

  /**
   * Procura recursivamente por uma propriedade 'role' em todos os valores do localStorage
   * e retorna seu valor (primeiro encontrado).
   */
  private getRoleFromLocalStorage(): string | null {
    const isObject = (v: any) => v !== null && typeof v === 'object';

    const findRole = (obj: any): string | null => {
      if (!obj) return null;
      if (typeof obj === 'string') return null;
      if (Array.isArray(obj)) {
        for (const el of obj) {
          const r = findRole(el);
          if (r) return r;
        }
      } else if (isObject(obj)) {
        // direct role
        if (obj.role && typeof obj.role === 'string') return obj.role;
        // case-insensitive search for keys that may contain role
        for (const key of Object.keys(obj)) {
          const val = (obj as any)[key];
          if (key.toLowerCase() === 'role' && typeof val === 'string') return val;
        }
        // recurse
        for (const key of Object.keys(obj)) {
          try {
            const r = findRole((obj as any)[key]);
            if (r) return r;
          } catch (e) {
            // ignore
          }
        }
      }
      return null;
    };

    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        try {
          const raw = localStorage.getItem(key);
          if (!raw) continue;
          // try parse JSON
          let parsed: any = null;
          try {
            parsed = JSON.parse(raw);
          } catch (e) {
            // not JSON, skip
            continue;
          }
          const found = findRole(parsed);
          if (found) return found;
        } catch (e) {
          // ignore per-key errors
        }
      }
    } catch (e) {
      // ignore overall errors
    }

    return null;
  }

  // Paginação
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 0;

  // Local storage key for pagination state (page and page size)
  private readonly PAGINATION_STATE_KEY = 'servicosPendentesPagination';

  /**
   * Persiste a página atual e o tamanho da página no localStorage.
   */
  private savePaginationState(): void {
    try {
      const payload = {
        paginaAtual: Number(this.paginaAtual) || 1,
        tamanhoPagina: Number(this.tamanhoPagina) || 50
      };
      localStorage.setItem(this.PAGINATION_STATE_KEY, JSON.stringify(payload));
    } catch (e) {
      // ignore storage errors
      console.warn('[WARN] Não foi possível salvar estado de paginação', e);
    }
  }

  /**
   * Carrega o estado de paginação salvo (se existir) e aplica aos campos.
   */
  private loadPaginationState(): void {
    try {
      const raw = localStorage.getItem(this.PAGINATION_STATE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed) return;
      const tamanho = Number(parsed.tamanhoPagina);
      const pagina = Number(parsed.paginaAtual);
      if (tamanho && !Number.isNaN(tamanho)) this.tamanhoPagina = tamanho;
      if (pagina && !Number.isNaN(pagina)) this.paginaAtual = pagina;
    } catch (e) {
      // ignore parse errors
    }
  }

  // Handler para mudança no select de tamanho de página
  onTamanhoPaginaChange(novoTamanho: number | string): void {
    const tamanho = Number(novoTamanho) || 50;
    if (this.tamanhoPagina === tamanho) return;
    this.tamanhoPagina = tamanho;
    this.paginaAtual = 1; // sempre resetar para a primeira página ao mudar o tamanho
    // Persistir alteração de tamanho/página
    try { this.savePaginationState(); } catch(e) { /* ignore */ }
    this.aplicarFiltro();
  }

  onFiltroDataFimChange(): void {
    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) return;

    // Allow the ngModel binding to settle, then apply the filter and persist
    setTimeout(() => {
      // Salvar filtro de período no localStorage ao alterar manualmente
      localStorage.setItem('filtroPeriodoServicosPendentes', JSON.stringify({
        inicio: this.filtroDataInicio,
        fim: this.filtroDataFim
      }));
      try {
        this.aplicarFiltro();
      } catch (e) {
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }

  @ViewChild('conteudoModal', { static: false }) conteudoModal!: ElementRef;
  htmlCompletoParaExportar: string = '';

  constructor(
    private usuarioService: UsuarioService,
    private servicoService: ServicoService,
    private recadastroService: RecadastroService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.currentUserRole = this.authService.getUserRoleSync() || '';

    // Buscar colaboradores e popular filtro
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = colaboradores.map((colaborador: any) => ({
          usuarioId: colaborador.usuarioId,
          nome: colaborador.nome
        }));
      },
      error: () => {
        this.erro = 'Erro ao carregar colaboradores.';
      }
    });
    // Preencher filtros de data para os últimos 7 dias (inclusivo)
    // Restaurar filtro de período do localStorage, se existir
    const periodoSalvo = localStorage.getItem('filtroPeriodoServicosPendentes');
    if (periodoSalvo) {
      try {
        const periodo = JSON.parse(periodoSalvo);
        if (periodo && periodo.inicio) this.filtroDataInicio = periodo.inicio;
        if (periodo && periodo.fim) this.filtroDataFim = periodo.fim;
      } catch (e) {
        // fallback: leave empty
        this.filtroDataInicio = '';
        this.filtroDataFim = '';
      }
    } else {
      try {
        const hoje = new Date();
        const fim = new Date(hoje);
        const inicio = new Date(hoje);
        inicio.setDate(hoje.getDate() - 7);
        // format yyyy-MM-dd for the input[type=date]
        const pad = (n: number) => n.toString().padStart(2, '0');
        this.filtroDataInicio = `${inicio.getFullYear()}-${pad(inicio.getMonth() + 1)}-${pad(inicio.getDate())}`;
        this.filtroDataFim = `${fim.getFullYear()}-${pad(fim.getMonth() + 1)}-${pad(fim.getDate())}`;
      } catch (e) {
        // fallback: leave empty
        this.filtroDataInicio = '';
        this.filtroDataFim = '';
      }
    }

  // Carrega estado de paginação previamente salvo (se existir)
  try { this.loadPaginationState(); } catch (e) { /* ignore */ }

  // Aplica filtro já com paginação possivelmente restaurada
  this.aplicarFiltro();
    // Se já existe um serviço em análise, redireciona automaticamente para ele ao abrir a tela de pendentes
    try {
      const existenteRaw = localStorage.getItem('servicoAnalise');
      if (existenteRaw) {
        const existente = JSON.parse(existenteRaw);
        if (existente && existente.id) {
          // Navega direto para a página de detalhes da análise em andamento
          setTimeout(() => {
            this.router.navigate(['/admin/servico-detalhes', existente.tipo || 'cadastro', existente.id]);
          }, 50);
        }
      }
    } catch (e) {
      // ignore parse errors
    }
  }
  // Retorna um valor de exibição para o número da OS (faz fallback por vários nomes comuns)
  formatNumeroOS(servico: any): string {
    if (!servico) return '-';
    const candidato = servico.numeroOS || servico.numeroOs || servico.numeroOrdem || servico.numero || servico.ordemNumero || servico.numeroOrdemFormatado || servico.osNumero || servico.osNumero1 || servico.osNumero2 || servico.osNumero3;
    if (!candidato && candidato !== 0) return '-';
    const s = candidato.toString();
    // Se já contém zeros à esquerda ou possui formatação não-numérica, devolve como está
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }
  aplicarFiltro(): void {
    this.spinner.show();
    this.erro = null;

    localStorage.setItem('filtroPeriodoServicosPendentes', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));

    if (this.filtroUsuarioId) {
      this.servicoService.obterTodosRegistrosPorPeriodo(
        this.filtroUsuarioId,
        this.filtroDataInicio,
        this.filtroDataFim,
        Number(this.paginaAtual),
        Number(this.tamanhoPagina),
        'pendente'
      ).subscribe({
        next: (response) => {
          this.processarDadosServicos(response);
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
          // OnPush: notify change detection
          try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
        },
        error: (err) => {
          this.erro = 'Erro ao carregar Vistoria pendentes. Tente novamente.';
          this.servicos = [];
          this.servicosFiltrados = [];
          this.spinner.hide();
        }
      });
    } else {
      // ⭐ 2º LOCAL: Usar sempre o método obterTodos para buscar registros pendentes

      if (this.filtroNumeroVistoria && this.filtroNumeroVistoria.toString().trim() !== '') {
        this.servicoService.obterTodos(
          undefined, // dataInicio
          undefined, // dataFim
          Number(this.paginaAtual),
          Number(this.tamanhoPagina),
          'pendente', // status -> ensure we filter only pendente when searching by numeroOS
          undefined, // nomeConsumidor
          undefined, // cpf
          undefined, // cnpj
          undefined, // matricula
          undefined, // cep
          undefined, // logradouro
          undefined, // bairro
          undefined, // cidade
          undefined, // estado
          undefined, // numero (logradouro)
          this.filtroNumeroVistoria, // numeroOS
          'Concluida' // statusOS -> include completed OS status when searching by numeroOS
        ).subscribe({
          next: (response) => {
            this.processarDadosServicos(response);
            this.atualizarInformacoesPaginacao(response);
            this.spinner.hide();
            try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
          },
          error: (err) => {
            this.erro = 'Erro ao carregar Vistoria pendentes. Tente novamente.';
            this.servicos = [];
            this.servicosFiltrados = [];
            this.spinner.hide();
          }
        });
        return;
      }

      // Caso geral: encaminha todos os filtros normalmente
      this.servicoService.obterTodos(
        this.filtroDataInicio,
        this.filtroDataFim,
        Number(this.paginaAtual),
        Number(this.tamanhoPagina),
        'pendente',
        this.filtroNomeConsumidor,
        this.filtroCpf,
        this.filtroCnpj,
        this.filtroMatricula,
        this.filtroCep,
        this.filtroLogradouro,
        this.filtroBairro,
        this.filtroCidade,
        this.filtroEstado,
        undefined,
        this.filtroNumeroVistoria, // numeroOS
        'Concluida'
      ).subscribe({
        next: (response) => {
          this.processarDadosServicos(response);
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
          // OnPush: notify change detection
          try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
        },
        error: (err) => {
          this.erro = 'Erro ao carregar Vistoria pendentes. Tente novamente.';
          this.servicos = [];
          this.servicosFiltrados = [];
          this.spinner.hide();
        }
      });
    }
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    // Reset date filters to empty so user can pick the period
    this.filtroDataInicio = '';
    this.filtroDataFim = '';
    this.tamanhoPagina = 50; // Reset page size to default
    this.paginaAtual = 1; // Reset to first page
    this.servicos = [];
    this.servicosFiltrados = [];
    this.erro = null;
    // reset filtros avancados
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
    try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
  }

  // Método para resetar e recarregar imediatamente
  resetarERecarregar(): void {
    this.resetarFiltro();
    this.aplicarFiltro();
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
  }

  private processarDadosServicos(response: any): void {
    // Para dados paginados, os registros estão no array 'itens' (português)
    const items = response?.itens || response?.items || [];

    let todosRegistros: any[] = [];

    // ⭐ 1º FILTRO: Processa os itens e filtra apenas os com status pendente
    if (items.length > 0) {
      todosRegistros = items
        .filter((item: any) => this.matchesRequiredStatus(item))
        .map((item: any) => {
          // Garante que dataServico sempre exista
          let dataServico = item.dataRecadastramento || item.dataCadastroOriginal || item.dataHoraInicio;
          if (!dataServico) dataServico = new Date().toISOString();
          return {
            ...item,
            tipoServico: this.determinarTipoServico(item),
            dataServico,
            cpfConsumidor: item.cpf,
            cnpjConsumidor: item.cnpj,
            telefoneConsumidor: item.telefone,
            latitudeInicio: item.latitudeInicio,
            longitudeInicio: item.longitudeInicio,
            latitudeFim: item.latitudeFim,
            longitudeFim: item.longitudeFim
          };
        });
    }

    if (this.filtroDataInicio || this.filtroDataFim) {
      // Quando o usuário filtra por período, manter a ordem que vem da API
      // (não aplicar ordenação local para não alterar a ordem fornecida pelo backend)
      this.servicos = todosRegistros;
    } else {
      // Caso padrão: mais recente primeiro
      this.servicos = todosRegistros.sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime());
    }
    this.servicosFiltrados = this.servicos;

    // Aplicar filtros adicionais se necessário
    this.aplicarFiltrosLocais();
    try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
  }

  private aplicarFiltrosLocais(): void {
    if (!this.servicos || this.servicos.length === 0) {
      this.servicosFiltrados = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.servicosFiltrados = this.servicos.filter(s => {
      if (!this.matchesRequiredStatus(s)) {
        return false;
      }
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
    try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
  }

  private normalizeStatusValue(value: any): string {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  private matchesRequiredStatus(item: any): boolean {
    if (!item) return false;
    const status = this.normalizeStatusValue(item.status);
    const statusOsRaw = item.statusOS ?? item.statusOs ?? item.status_os;
    const statusOs = this.normalizeStatusValue(statusOsRaw);
    return status === 'pendente' && statusOs === 'concluida';
  }

  isStatusOsConcluida(item: any): boolean {
    const statusOsRaw = item?.statusOS ?? item?.statusOs ?? item?.status_os;
    return this.normalizeStatusValue(statusOsRaw) === 'concluida';
  }

  getStatusDisplay(servico: any): string {
    if (!servico || !servico.status) return 'Pendente';
    return servico.status;
  }

  getStatusOsDisplay(servico: any): string {
    if (!servico) return 'Concluida';
    const raw = servico.statusOS ?? servico.statusOs ?? servico.status_os;
    return raw || 'Concluida';
  }

  private determinarTipoServico(item: any): string {
    // Se tem recadastroId e não é o UUID vazio, é recadastro
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    // Caso contrário é cadastro
    return 'cadastro';
  }

  verDetalhes(registro: any): void {

    const tipo = registro.tipoServico === 'recadastro' ? 'recadastro' : 'cadastro';
    const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
    let id = '';

    if (tipo === 'recadastro') {
      if (registro.recadastroId && registro.recadastroId !== ZERO_UUID) {
        id = registro.recadastroId;
      } else if (registro.cadastroId && registro.cadastroId !== ZERO_UUID) {
        id = registro.cadastroId;
      } else if (registro.id && registro.id !== ZERO_UUID) {
        id = registro.id;
      }
    } else {
      if (registro.cadastroId && registro.cadastroId !== ZERO_UUID) {
        id = registro.cadastroId;
      } else if (registro.id && registro.id !== ZERO_UUID) {
        id = registro.id;
      } else if (registro.recadastroId && registro.recadastroId !== ZERO_UUID) {
        id = registro.recadastroId;
      }
    }

    if (!id) {
      console.warn('[WARN] verDetalhes: nenhum id válido encontrado para registro', registro);
      id = registro.cadastroId || registro.recadastroId || registro.id || '';
    }

    let adminUsuarioId: string | null = null;
    const stored = this.getStoredUser();
    if (stored) {
      // várias convenções possíveis: stored.usuario.usuarioId, stored.usuarioId, stored.usuarioId (top-level), stored.usuario.usuarioId
      adminUsuarioId = stored.usuario?.usuarioId || stored.usuario?.id || stored.usuarioId || stored.id || stored.user?.id || stored.user?.usuarioId || null;
      // se o stored tiver um campo usuario e dentro dele um objeto com usuarioId como string (algumas versões usam usuario.usuarioId)
    }

    const navigateToDetails = () => this.router.navigate(['/admin/servico-detalhes', tipo, id]);

    // extrai token de possíveis locais no localStorage
    const possibleTokenKeys = ['token', 'authToken', 'accessToken', 'userToken'];
    let token: string | undefined;
    try {
      for (const k of possibleTokenKeys) {
        const v = localStorage.getItem(k);
        if (v) { token = v; break; }
      }
      // fallback: token inside userData
      if (!token) {
        const stored = this.getStoredUser();
        if (stored) {
          token = stored.token || stored.authToken || stored.tokenJWT || stored.tokenJwt || stored.user?.token || stored.usuario?.token;
        }
      }
    } catch (e) {
      token = undefined;
    }

    if (!adminUsuarioId) {
      console.warn('[WARN] verDetalhes: adminUsuarioId não encontrado no localStorage, não iniciando análise');
      alert('Usuário administrador não encontrado. Não é possível iniciar análise.');
      return;
    }

    // Se já existe um serviço em análise salvo no localStorage, abrir ele em vez de iniciar outro
    try {
      const existenteRaw = localStorage.getItem('servicoAnalise');
      if (existenteRaw) {
        const existente = JSON.parse(existenteRaw);
        if (existente && existente.id) {
          // Se for o mesmo id, só navegar direto
          if (existente.id === id) {
            navigateToDetails();
            return;
          }
          // Se for outro id, perguntar ao usuário se quer retomar o existente
          const confirmar = confirm('Existe uma análise em andamento para outro cadastro. Deseja retomar a análise existente em vez de iniciar uma nova?');
          if (confirmar) {
            this.router.navigate(['/admin/servico-detalhes', existente.tipo || 'cadastro', existente.id]);
            return;
          }
          // se o usuário não quer retomar, prosseguimos para iniciar a nova análise
        }
      }
    } catch (e) {
      // se parse falhar, prosseguir normalmente
    }

    // inicia a análise no backend antes de redirecionar — navegar apenas se a chamada retornar sucesso
    this.spinner.show();
    const observable = tipo === 'recadastro'
      ? this.servicoService.iniciarAnaliseRecadastro(id, adminUsuarioId, token)
      : this.servicoService.iniciarAnaliseCadastro(id, adminUsuarioId, token);
    observable.subscribe({
      next: () => {
        this.spinner.hide();
        // salva estado de análise no localStorage
        try {
          const now = new Date().toISOString();
          const item = { id, tipo, adminUsuarioId, startedAt: now };
          localStorage.setItem('servicoAnalise', JSON.stringify(item));
        } catch (e) {
          console.warn('[WARN] Não foi possível salvar servicoAnalise no localStorage', e);
        }
        navigateToDetails();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('[ERROR] iniciarAnalise falhou', err);
        const msg = err?.error?.message || err?.message || 'Erro ao iniciar análise. Tente novamente.';
        alert(msg);
      }
    });
  }

  inicializarMapaServico(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapServico) {
      (window as any)._mapServico.remove();
      (window as any)._mapServico = null;
    }

    const latInicio = this.servicoDetalhes?.latitudeInicio;
    const lngInicio = this.servicoDetalhes?.longitudeInicio;
    const latFim = this.servicoDetalhes?.latitudeFim;
    const lngFim = this.servicoDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-cadastro');

    if (!divMapa) {
      console.error('Elemento map-cadastro não encontrado');
      return;
    }

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    // Só mostra o mapa se pelo menos um ponto existir
    if (latInicio && lngInicio || latFim && lngFim) {
      try {
        const map = L.map('map-cadastro').setView([latInicio || latFim, lngInicio || lngFim], 15);
        (window as any)._mapServico = map;

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap'
        }).addTo(map);

        if (latInicio && lngInicio) {
          L.marker([latInicio, lngInicio], {
            icon: L.icon({
              iconUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png',
              iconSize: [25, 41],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png',
              shadowSize: [41, 41]
            })
          }).addTo(map).bindPopup('Início');
        }

        if (latFim && lngFim) {
          L.marker([latFim, lngFim], {
            icon: L.icon({
              iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
              iconSize: [25, 41],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png',
              shadowSize: [41, 41]
            })
          }).addTo(map).bindPopup('Fim');
        }

        // Se existem ambos os pontos, ajustar a visualização para mostrar ambos
        if (latInicio && lngInicio && latFim && lngFim) {
          const bounds = L.latLngBounds([
            [latInicio, lngInicio],
            [latFim, lngFim]
          ]);
          map.fitBounds(bounds, { padding: [20, 20] });
        }

      } catch (error) {
        console.error('Erro ao inicializar mapa:', error);
        divMapa.innerHTML = '<div class="d-flex align-items-center justify-content-center h-100 text-muted"><i class="bi bi-exclamation-triangle me-2"></i>Erro ao carregar mapa</div>';
      }
    } else {
      divMapa.innerHTML = '<div class="d-flex align-items-center justify-content-center h-100 text-muted"><i class="bi bi-geo-alt-slash me-2"></i>Coordenadas não disponíveis</div>';
    }
  }

  fecharModalDetalhes(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapServico) {
      (window as any)._mapServico.remove();
      (window as any)._mapServico = null;
    }

    // Reseta os estados de validação
    this.processandoStatus = false;
    this.statusProcessado = false;
    this.statusFinal = null;

    this.servicoDetalhes = null;
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = this.getFullImageUrl(url);
    this.mostrarModalFoto = true;
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
  }

  validarServico(): void {
    if (!this.servicoDetalhes) return;

    this.processandoStatus = true;
    this.statusFinal = 'Validado';
    this.spinner.show();

    // Determina qual método usar baseado no tipo de serviço
    const isRecadastro = this.servicoDetalhes.recadastroId && this.servicoDetalhes.recadastroId !== "00000000-0000-0000-0000-000000000000";
    const id = isRecadastro ? this.servicoDetalhes.recadastroId : this.servicoDetalhes.cadastroId;

    const serviceCall = isRecadastro
      ? this.servicoService.atualizarStatusRecadastro(id, 'Validado')
      : this.servicoService.atualizarStatusCadastro(id, 'Validado');

    serviceCall.subscribe({
      next: () => {
        this.spinner.hide();
        this.processandoStatus = false;
        this.statusProcessado = true;

        // Recarrega a lista após 2 segundos
        setTimeout(() => {
          this.aplicarFiltro();
        }, 2000);
      },
      error: () => {
        this.spinner.hide();
        this.processandoStatus = false;
        this.statusProcessado = false;
        this.statusFinal = null;
        this.erro = 'Erro ao validar vistoria. Tente novamente.';
      }
    });
  }

  invalidarServico(): void {
    if (!this.servicoDetalhes) return;
    this.motivoInvalidoTouched = false;
    this.motivoInvalido = '';
    this.mostrarModalInvalida = true;
  }

  confirmarInvalidacao(): void {
    this.motivoInvalidoTouched = true;
    if (!this.motivoInvalido || this.motivoInvalido.trim().length < 3) {
      return;
    }
    this.processandoStatus = true;
    this.statusFinal = 'Invalido';
    this.mostrarModalInvalida = false;
    this.spinner.show();
    // Determina qual método usar baseado no tipo de serviço
    const isRecadastro = this.servicoDetalhes.recadastroId && this.servicoDetalhes.recadastroId !== "00000000-0000-0000-0000-000000000000";
    const id = isRecadastro ? this.servicoDetalhes.recadastroId : this.servicoDetalhes.cadastroId;
    if (isRecadastro) {
      // Primeiro desatribui o recadastro
      this.recadastroService.atribuirRecadastro(id, false).subscribe({
        next: () => {
          // Depois de desatribuir, faz a invalidação
          this.servicoService.atualizarStatusRecadastro(id, 'Invalido', this.motivoInvalido).subscribe({
            next: () => {
              this.spinner.hide();
              this.processandoStatus = false;
              this.statusProcessado = true;
              setTimeout(() => {
                this.aplicarFiltro();
              }, 2000);
            },
            error: () => {
              this.spinner.hide();
              this.processandoStatus = false;
              this.statusProcessado = false;
              this.statusFinal = null;
              alert('Erro ao invalidar vistoria. Tente novamente.');
            }
          });
        },
        error: () => {
          this.spinner.hide();
          this.processandoStatus = false;
          this.statusProcessado = false;
          this.statusFinal = null;
          alert('Erro ao desatribuir recadastro. Tente novamente.');
        }
      });
    } else {
      // Cadastro normal
      this.servicoService.atualizarStatusCadastro(id, 'Invalido', this.motivoInvalido).subscribe({
        next: () => {
          this.spinner.hide();
          this.processandoStatus = false;
          this.statusProcessado = true;
          setTimeout(() => {
            this.aplicarFiltro();
          }, 2000);
        },
        error: () => {
          this.spinner.hide();
          this.processandoStatus = false;
          this.statusProcessado = false;
          this.statusFinal = null;
          alert('Erro ao invalidar vistoria. Tente novamente.');
        }
      });
    }
  }

  cancelarInvalidacao(): void {
    this.mostrarModalInvalida = false;
    this.motivoInvalido = '';
  }

  exportarServicoParaPDF(): void {
    if (!this.servicoDetalhes) return;

    // Salva os dados do serviço antes de fechar o modal
    const dadosServico = { ...this.servicoDetalhes };

    // Busca o modal-body original
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    // Cria um clone do modal-body para captura
    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    // Configura o clone para captura completa mas visível para html2canvas
    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    // Adiciona o clone ao body temporariamente
    document.body.appendChild(modalBodyClone);

    // Fecha o modal imediatamente para melhor UX
    this.fecharModalDetalhes();

    // Aguarda um momento para o clone renderizar completamente
    setTimeout(() => {
      html2canvas(modalBodyClone, {
        scale: 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        logging: true,
        width: modalBodyClone.scrollWidth,
        height: modalBodyClone.scrollHeight
      }).then((canvas: HTMLCanvasElement) => {

        document.body.removeChild(modalBodyClone);


        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 8;
        const contentWidth = pdfWidth - (margin * 2);
        const pageContentHeight = pdfHeight - (margin * 2);

        // Proporção da imagem para o PDF
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;

        // Altura do canvas em pixels correspondente a uma página PDF
        const pageHeightPx = Math.floor((pageContentHeight * canvas.height) / imgHeight);
        const minRestPx = 100; // altura mínima para não cortar elemento grande
        let renderedHeight = 0;
        let pageNum = 1;

        while (renderedHeight < canvas.height) {
          let pageCanvasHeight = Math.min(pageHeightPx, canvas.height - renderedHeight);
          // Se o restante do canvas for menor que minRestPx, pule para próxima página
          if (canvas.height - (renderedHeight + pageCanvasHeight) < minRestPx && (canvas.height - renderedHeight) > pageHeightPx) {
            pageCanvasHeight = canvas.height - renderedHeight - minRestPx;
          }

          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageCanvasHeight;

          // Copia a parte do canvas para a página
          pageCtx?.drawImage(
            canvas,
            0, renderedHeight, canvas.width, pageCanvasHeight,
            0, 0, canvas.width, pageCanvasHeight
          );

          const pageImgData = pageCanvas.toDataURL('image/png');
          const pageImgHeight = (pageCanvasHeight * imgWidth) / canvas.width;

          if (pageNum > 1) pdf.addPage();
          pdf.addImage(pageImgData, 'PNG', margin, margin, imgWidth, pageImgHeight);

          renderedHeight += pageCanvasHeight;
          pageNum++;
        }

        // Usa os dados salvos para o nome do arquivo
        const nome = dadosServico?.nomeConsumidor?.replace(/\s/g, '_') || 'servico';
        pdf.save(`${nome}_servico.pdf`);
      }).catch((error: any) => {

        if (document.body.contains(modalBodyClone)) {
          document.body.removeChild(modalBodyClone);
        }
        alert('Erro ao gerar o PDF. Tente novamente.');
      });
    }, 500);
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Subtract 7 days so the period covers the last 7 days up to today (inclusive)
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  /**
   * Formata dinamicamente CPF ou CNPJ com base na quantidade de dígitos.
   * - 11 dígitos => CPF (000.000.000-00)
   * - 14 dígitos => CNPJ (00.000.000/0000-00)
   * Caso contrário, retorna a string apenas com dígitos.
   */
  formatCpfCnpj(raw?: string | null): string {
    if (!raw) return '';
    const digits = String(raw).replace(/\D/g, '');
    if (digits.length === 11) return this.maskCpf(digits);
    if (digits.length === 14) return this.maskCnpj(digits);
    return digits;
  }

  /**
   * Extrai o campo disponível (várias convenções: cpfConsumidor, cnpjConsumidor, cpfCnpj, cpf, cnpj)
   * e retorna a string já formatada para exibição, ou '-' se não houver valor.
   */
  getCpfCnpjDisplay(servico: any): string {
    if (!servico) return '-';
    const candidates = [
      servico.cpfConsumidor,
      servico.cnpjConsumidor,
      servico.cpfCnpj,
      servico.cpf,
      servico.cnpj,
      servico.cpfCnpjConsumidor,
      servico.cpf_cnpj
    ];
    for (const c of candidates) {
      if (c !== undefined && c !== null && String(c).toString().trim() !== '') {
        const formatted = this.formatCpfCnpj(String(c));
        return formatted || '-';
      }
    }
    return '-';
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  // ---- Methods added to match `servicos` template bindings ----
  getDataAnalise(servico: any): any {
    if (!servico) return null;
    return servico.dataHoraInicioAnalise || servico.dataAnaliseInicio || servico.dataInicioAnalise || servico.dataAnaliseAtendimento || servico.dataAnaliseUsuario || servico.dataAnaliseHora || servico.dataServico || servico.dataRecadastramento || servico.dataCadastroOriginal || servico.dataHoraInicio || null;
  }

  getUsuarioDisplay(servico: any): string {
    if (!servico) return '-';
    return servico.analisadoPorNome || servico.nomeUsuario || servico.usuario?.nome || servico.usuario || servico.nome || servico.nomeConsumidor || '-';
  }

  getItemInicio(): number {
    if (!this.totalItens || this.totalItens === 0) return 0;
    return ((this.paginaAtual - 1) * this.tamanhoPagina) + 1;
  }

  getItemFim(): number {
    if (!this.totalItens || this.totalItens === 0) return 0;
    return Math.min(this.paginaAtual * this.tamanhoPagina, this.totalItens);
  }

  alterarTamanhoPagina(novoTamanho: number): void {
    // adapter to onTamanhoPaginaChange
    this.onTamanhoPaginaChange(novoTamanho);
  }


  getTipoServico(registro: any): string {
    // Usa o mesmo método para determinar o tipo de serviço
    return this.determinarTipoServico(registro);
  }

  getEnderecoCompleto(servico: any): string {
    // Se tem objeto endereco, usa ele
    if (servico.endereco) {
      const { logradouro, numero, bairro, cidade } = servico.endereco;
      return `${logradouro || ''} ${numero || ''}, ${bairro || ''}, ${cidade || ''}`.trim();
    }

    // Fallback para campos diretos (caso antigo)
    if (servico.logradouro) {
      return `${servico.logradouro || ''} ${servico.numero || ''}, ${servico.bairro || ''}, ${servico.cidade || ''}`.trim();
    }

    return '-';
  }

  private atualizarInformacoesPaginacao(response: any): void {
    // Sempre use o totalItens da resposta da API se existir
    if (response && typeof response.totalItens === 'number') {
      this.totalItens = response.totalItens;
      this.totalPaginas = Math.ceil(this.totalItens / this.tamanhoPagina);
    } else {
      // Se não vier totalItens, considere 0 (não use mais o tamanho do array local)
      this.totalItens = 0;
      this.totalPaginas = 1;
    }
  }

  // Métodos de navegação da paginação
  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      try { this.savePaginationState(); } catch(e) { /* ignore */ }
      this.aplicarFiltro();
    }
  }

  private processarDadosPaginados(response: any): void {
    // Processa apenas os dados da página atual sem ordenação
    const items = response?.itens || response?.items || [];

    // ⭐ 2º FILTRO: Filtra apenas registros pendentes
  const registrosPendentes = items
      .filter((item: any) => this.matchesRequiredStatus(item))
      .map((item: any) => ({
        ...item,
        tipoServico: this.determinarTipoServico(item),
        dataServico: item.dataRecadastramento || item.dataCadastroOriginal || item.dataHoraInicio,
        cpfConsumidor: item.cpf,
        cnpjConsumidor: item.cnpj,
        telefoneConsumidor: item.telefone,
        latitudeInicio: item.latitudeInicio,
        longitudeInicio: item.longitudeInicio,
        latitudeFim: item.latitudeFim,
        longitudeFim: item.longitudeFim
      }));

    this.servicos = registrosPendentes;
    this.servicosFiltrados = registrosPendentes;
    this.aplicarFiltrosLocais();
    this.atualizarInformacoesPaginacao(response);
    try { this.cdr.markForCheck(); } catch(e) { /* ignore */ }
  }

  // trackBy for ngFor to avoid unnecessary DOM recreation
  trackById(index: number, item: any): any {
    return item?.id || item?.cadastroId || item?.recadastroId || index;
  }

  onVer(servico: any): void {
    if (!servico) return;

    const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
    const idRef = servico.cadastroId || servico.recadastroId || servico.id;
    if (!idRef || idRef === ZERO_UUID) {
      console.warn('Serviço sem ID válido', servico);
      return;
    }

    this.viewLoading[idRef] = true;
    this.spinner.show();

    const releaseLoading = () => {
      this.viewLoading[idRef] = false;
      this.spinner.hide();
    };

    const queryParams: any = {};
    const appendDateRange = (iso?: string | null) => {
      if (!iso) return;
      const parsed = new Date(iso);
      if (Number.isNaN(parsed.getTime())) return;
      const day = parsed.toISOString().split('T')[0];
      queryParams.filtroDataInicio = `${day}T00:00:00`;
      queryParams.filtroDataFim = `${day}T23:59:59`;
    };
    const navigateWithParams = () => {
      this.ngZone.run(() => {
        this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
          .then(() => releaseLoading())
          .catch(() => releaseLoading());
      });
    };

    // API agora retorna um resumo, então resolvemos os detalhes completos antes de navegar.
    const isRecadastro = !!(servico.recadastroId && servico.recadastroId !== ZERO_UUID);
    const idParaBuscar = isRecadastro
      ? servico.recadastroId
      : servico.cadastroId || servico.id;

    if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
      console.warn('Nenhum identificador encontrado para busca', servico);
      releaseLoading();
      return;
    }

    const detalhes$ = isRecadastro
      ? this.servicoService.obterRecadastroPorId(idParaBuscar)
      : this.servicoService.obterCadastroPorId(idParaBuscar);

    detalhes$.subscribe({
      next: (detalhes) => {
        const usuarioId = detalhes?.usuarioId || servico.usuarioId;
        if (usuarioId) queryParams.usuarioId = usuarioId;

        const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk
          || servico.idJuncao || servico.IdJuncao || servico.idjuncao || servico.idJuncaoFk;

        if (isRecadastro) {
          const recadastroId = detalhes?.recadastroId || servico.recadastroId || idParaBuscar;
          if (recadastroId && recadastroId !== ZERO_UUID) queryParams.recadastroId = recadastroId;
        } else {
          const cadastroId = detalhes?.cadastroId || servico.cadastroId || idParaBuscar;
          if (cadastroId && cadastroId !== ZERO_UUID) queryParams.cadastroId = cadastroId;
        }

        const fallbackToCurrentFilters = () => {
          if (!queryParams.filtroDataInicio && this.filtroDataInicio) {
            queryParams.filtroDataInicio = this.filtroDataInicio;
          }
          if (!queryParams.filtroDataFim && this.filtroDataFim) {
            queryParams.filtroDataFim = this.filtroDataFim;
          }
          navigateWithParams();
        };

        if (idJuncao && idJuncao !== ZERO_UUID) {
          queryParams.idJuncao = idJuncao;
          this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
            next: (detalhesCompletos) => {
              appendDateRange(detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio);
              if (detalhesCompletos?.recadastroId) {
                queryParams.recadastroId = detalhesCompletos.recadastroId;
                delete queryParams.cadastroId;
              } else if (detalhesCompletos?.cadastroId) {
                queryParams.cadastroId = detalhesCompletos.cadastroId;
                delete queryParams.recadastroId;
              }
              navigateWithParams();
            },
            error: (err) => {
              console.error('Erro ao buscar detalhes por idJuncao', err);
              appendDateRange(detalhes?.dataHoraInicio);
              fallbackToCurrentFilters();
            }
          });
          return;
        }

        appendDateRange(detalhes?.dataHoraInicio);
        fallbackToCurrentFilters();
      },
      error: (err) => {
        console.error('Erro ao buscar detalhes do cadastro/recadastro', err);
        if (isRecadastro && idParaBuscar && idParaBuscar !== ZERO_UUID) {
          queryParams.recadastroId = idParaBuscar;
        } else if (idParaBuscar && idParaBuscar !== ZERO_UUID) {
          queryParams.cadastroId = idParaBuscar;
        }
        if (servico.usuarioId) {
          queryParams.usuarioId = servico.usuarioId;
        }
        if (this.filtroDataInicio) queryParams.filtroDataInicio = this.filtroDataInicio;
        if (this.filtroDataFim) queryParams.filtroDataFim = this.filtroDataFim;
        navigateWithParams();
      }
    });
  }

  obterPaginas(): number[] {
    const paginas: number[] = [];
    const maxPaginas = 3; // Máximo de páginas a mostrar
    const metade = Math.floor(maxPaginas / 2);

    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginas - 1);

    // Ajusta o início se o fim alcançou o total
    if (fim - inicio < maxPaginas - 1) {
      inicio = Math.max(1, fim - maxPaginas + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }
}